import { render, staticRenderFns } from "./ColorPaletteConfig.vue?vue&type=template&id=5afe19cd&scoped=true"
import script from "./ColorPaletteConfig.vue?vue&type=script&lang=js"
export * from "./ColorPaletteConfig.vue?vue&type=script&lang=js"
import style0 from "./ColorPaletteConfig.vue?vue&type=style&index=0&id=5afe19cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afe19cd",
  null
  
)

export default component.exports